import React, { useEffect, useState } from 'react'
import { EditPageHeader } from '../../../components/EditPageHeader'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { ENTITYNAME, LOCALSTORAGE_KEY, PLAYLIST_SCHEDULE_TYPE, PLAYLIST_STATUS } from '../../../framework/constant/constant'
import { utility } from '../../../framework/utility/utilityProvider'
import { PlaylistHelper } from './PaylistHelper'
import { useTranslation } from '../../../locale/useTranslation'
import moment from 'moment'
import BossDialog from '../../../components/BossDialog'
import * as API_DIGI_SIGN from "../../../framework/API/api_digitalSign";
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

const SchedulePlaylistPopup = (props) => {

    const lang = useTranslation();
    const navigate = useNavigate();
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    const [currentPlaylistItem, setCurrentPlaylistItem] = useState({});
    const [scheduleDataItem, setScheduleDataItem] = useState({
        ScheduleType: props.scheduleTypeByDefault ? props.scheduleTypeByDefault : PLAYLIST_SCHEDULE_TYPE.OnPriorityTakeover,
        StartDate: null, // moment(new Date()).format("YYYY-MM-DD"),
        EndDate: null, //moment(new Date()).add(1, "days").format("YYYY-MM-DD"),
        isNoEndDate: true
    });

    console.log(scheduleDataItem);


    useEffect(() => {
        setCurrentPlaylistItem(props.playlistItem);

        let defaultStartDate = moment().add(1, 'days').utc().format('YYYY-MM-DDT00:00');
        let defaultEndDate = moment().add(1, 'days').utc().format('YYYY-MM-DDT23:59');

        let scheduleItem = {
            ...props,
            ...props.playlistItem?.Schedule,
            ScheduleType: props.scheduleTypeByDefault ? props.scheduleTypeByDefault : PLAYLIST_SCHEDULE_TYPE.OnPriorityTakeover,
            StartDate: props.playlistItem?.Schedule?.StartDate
                ? moment(new Date(props.playlistItem?.Schedule?.StartDate)).utc().format('YYYY-MM-DDTHH:mm')
                : props.scheduleTypeByDefault === PLAYLIST_SCHEDULE_TYPE.SetDateRange ? defaultStartDate : "",
            EndDate: props.playlistItem?.Schedule?.EndDate
                ? moment(new Date(props.playlistItem?.Schedule?.EndDate)).utc().format('YYYY-MM-DDTHH:mm')
                : props.scheduleTypeByDefault === PLAYLIST_SCHEDULE_TYPE.SetDateRange ? defaultEndDate : "",
            isNoEndDate: props.scheduleTypeByDefault !== PLAYLIST_SCHEDULE_TYPE.SetDateRange
        };
        console.log(scheduleItem);
        setScheduleDataItem(scheduleItem);


    }, [props.playlistItem, props.scheduleTypeByDefault]);


    const onScheduleDataItemChange = (e) => {
        console.log(e);

        if (e.target.name == "isNoEndDate") {
            setScheduleDataItem({
                ...scheduleDataItem,
                isNoEndDate: !scheduleDataItem.isNoEndDate, EndDate: !scheduleDataItem.isNoEndDate ? '' : scheduleDataItem.EndDate
            });
        } else if (e?.target?.name == "ScheduleType") {
            let item = { ...scheduleDataItem, ScheduleType: e?.target?.value?._id };
            if (e.target?.value?._id == PLAYLIST_SCHEDULE_TYPE?.OnPriorityTakeover) {
                item = { ...item, StartDate: '', EndDate: '', isNoEndDate: true };
            } else {
                item = {
                    ...item,
                    StartDate: currentPlaylistItem?.Schedule?.StartDate ? moment(new Date(currentPlaylistItem?.Schedule?.StartDate)).utc().format('YYYY-MM-DDT00:00') : moment(new Date()).utc().format('YYYY-MM-DDT00:00'),
                    EndDate: currentPlaylistItem?.Schedule?.EndDate ? moment(new Date(currentPlaylistItem?.Schedule?.EndDate)).utc().format('YYYY-MM-DDT23:59') : moment(new Date()).add(1, 'd').utc().format('YYYY-MM-DDT23:59'),
                    isNoEndDate: false
                };
                console.log(item)
            }
            setScheduleDataItem(item);
        } else {
            setScheduleDataItem({ ...scheduleDataItem, [e.target.name]: e.target.value });
        }
    }

    const handleSchedulePlaylist = async () => {
        if (props.isMainForm) {
            let screenGroupId = "";
            let Company_id = company?._id;
    
            // Fetch screen group based on Company_id
            let screenGroupRes = await API_DIGI_SIGN.getData(ENTITYNAME.DigitalSignScreenGroup, {
                query: ["Company_id", "=", Company_id]
            });
    
            if (screenGroupRes.success && screenGroupRes.data.length > 0) {
                screenGroupId = screenGroupRes.data[0]._id;
            }
    
            // Handle screenGroup input from props
            let screenGroupInput = props.playlistItem.screenGroup;
            let screenGroup = [];
    
            if (Array.isArray(screenGroupInput) && screenGroupInput.length > 0) {
                if (typeof screenGroupInput[0] === 'object' && screenGroupInput[0]?._id) {
                    screenGroup = screenGroupInput
                        .map(group => group?._id)
                        .filter(id => !!id);
                } else if (typeof screenGroupInput[0] === 'string') {
                    screenGroup = screenGroupInput.filter(id => !!id);
                }
            } else if (screenGroupId) {
                screenGroup = [screenGroupId];
            }
    
            let saveData = {
                _id: props.playlistItem?._id,
                SID: props.playlistItem?.SID ?? 0,
                Name: props.playlistItem?.Name ?? 'Untitled Playlist',
                screenGroup: screenGroup,
                Status: PLAYLIST_STATUS.UnPublished,
                Schedule: {
                    ScheduleType: PLAYLIST_SCHEDULE_TYPE.SetDateRange ?? PLAYLIST_SCHEDULE_TYPE.OnPriorityTakeover,
                    StartDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(scheduleDataItem?.StartDate)),
                    EndDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(scheduleDataItem?.EndDate)),
                    isNoEndDate: scheduleDataItem?.isNoEndDate ?? true,
                },
                Company_id: Company_id
            };
    
            console.log(saveData);
    
            let res = await API_DIGI_SIGN.saveData(ENTITYNAME.DigitalSignPlaylist, saveData);
            console.log(res);
    
            if (res.success) {
                toast.success('Save successfully');
                navigate(`/home/PlaylistItem/${res.data?._id}`);
            } else {
                toast.error('Error creating new Playlist. Try again');
                return null;
            }
        } else {
            let res = await PlaylistHelper.handleSchedulePlaylist(currentPlaylistItem, scheduleDataItem);
            if (res.success) {
                props.close();
                props.refresh();
            }
        }
    };
    

    return (
        <BossDialog title={"Schedule Playlist"} onClose={props.close} width={"600px"}>
            <div className="row">
                <div className="col-12">
                    <EditPageHeader saveButtonTitle={"Schedule"} showTitle={false} onSubmit={handleSchedulePlaylist} onCancel={props.close} />
                    <div className='row mt-3'>
                        <div className='col-8'>
                            <label>{lang.schedule_type_label} *</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={Object.keys(PLAYLIST_SCHEDULE_TYPE).map((key) => ({ _id: PLAYLIST_SCHEDULE_TYPE[key], Description: utility.convertCamelCaseToWords(key) }))}
                                name="ScheduleType"
                                textField="Description"
                                dataItemKey="_id"
                                value={Object.keys(PLAYLIST_SCHEDULE_TYPE).map((key) => ({ _id: PLAYLIST_SCHEDULE_TYPE[key], Description: utility.convertCamelCaseToWords(key) })).find(x => x._id == scheduleDataItem.ScheduleType)}
                                onChange={onScheduleDataItemChange}
                            />
                        </div>
                    </div>
                    {scheduleDataItem.ScheduleType === PLAYLIST_SCHEDULE_TYPE.SetDateRange && (
                        <div className="row mt-3">
                            <div className='col-4'>
                                <label htmlFor="">{lang.start_date_label} *</label>
                                <input
                                    type="datetime-local"
                                    className="form-control form-control-sm"
                                    name="StartDate"
                                    value={scheduleDataItem.StartDate}
                                    onChange={onScheduleDataItemChange}
                                    disabled={scheduleDataItem.ScheduleType === PLAYLIST_SCHEDULE_TYPE.OnPriorityTakeover}
                                />
                            </div>
                            <div className='col-4'>
                                <label htmlFor="">{lang.end_Date_label} *</label>
                                <input
                                    type="datetime-local"
                                    className="form-control form-control-sm"
                                    name="EndDate"
                                    value={scheduleDataItem.EndDate}
                                    onChange={onScheduleDataItemChange}
                                    disabled={scheduleDataItem.ScheduleType === PLAYLIST_SCHEDULE_TYPE.OnPriorityTakeover || scheduleDataItem.isNoEndDate}
                                />
                            </div>
                            <div className='col-4 mt-4'>
                                <input
                                    type="checkbox"
                                    name="isNoEndDate"
                                    onChange={onScheduleDataItemChange}
                                    checked={scheduleDataItem.isNoEndDate}
                                    disabled={scheduleDataItem.ScheduleType === PLAYLIST_SCHEDULE_TYPE.OnPriorityTakeover}
                                />
                                <label className="ml-1">{lang.no_end_date_label}</label>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </BossDialog>
    )
}


export default SchedulePlaylistPopup